import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Project } from '../../../features/project/models/project';
import { AppMenu } from '../../models/app-menu';
import { StateService } from '@uirouter/core';

import { User } from '../../../features/users/models/user';
import { ProjectPage } from '@/app/features/project/models/project-page';
import { ProjectConfigurationBehaviorSubjectService } from '../../../features/project/services/project-configuration-behavior-subject.service';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { ProjectConfiguration } from '@/app/features/project/models/project-configuration';
import { ProjectDataService } from '../../../features/project/services/project-data.service';

import { map, switchMap } from 'rxjs/operators';
import { UserProfileService } from '../../../features/users/services/user-profile.service';
@Component({
  selector: 'app-nav-bar',
  template: require('./nav-bar.component.html'),
  styles: [require('./nav-bar.component.sass')]
})
export class NavBarComponent implements OnInit {

  activePages: ProjectPage[];
  projectId: number;

  @Input() show: boolean;
  @Input() selectedProject: Project;
  @Input() currentUser: User;
  @Output() logout = new EventEmitter();

  projects$: Observable<Project[]>;
  currentTimezone: string;
  
  projectConfigurationSubscription: Subscription;

  projectConfiguration: ProjectConfiguration;
  activeProjectConfigurations: ProjectConfiguration[];

  private readonly refreshProjects$ = new BehaviorSubject(undefined);

  constructor(
    @Inject('ProjectService') private projectService: any,
    private projectConfigurationBehaviorSubjectService: ProjectConfigurationBehaviorSubjectService,
    @Inject('ConfigurationStoreService') private configurationStoreService: any,
    public $state: StateService,
    private projectDataService: ProjectDataService,
    private userProfileService: UserProfileService
  ) {
    this.projectId = this.$state.params && this.$state.params.projectId;
    this.projects$ = this.refreshProjects$.pipe(
        switchMap(() => this.projectDataService.getAllProjects()),
        map(projects => projects.filter(project => project.id > 0)));  
   }

  ngOnInit(): void {

    this.refreshProjects$.next(undefined);

    this.projectConfigurationSubscription = this.projectConfigurationBehaviorSubjectService.changeOccured.subscribe(() => {
      this.projectConfiguration = this.configurationStoreService.getProjectConfiguration(this.projectId);
      this.activeProjectConfigurations = this.configurationStoreService.getActiveProjectConfigurations();
      this.refreshProjects$.next(undefined);
    })
    
    if (this.projectId > 0) {
      this.activePages = this.currentUser && this.currentUser.projectPageSet && this.currentUser.projectPageSet[this.projectId] || [];
    } else {
      this.activePages = this.currentUser && this.currentUser.projectPageSet && [...new Set(Object.keys(this.currentUser.projectPageSet).reduce((acc: ProjectPage[], projectId) => {
        return [
          ...acc,
          ...(this.currentUser.projectPageSet && this.currentUser.projectPageSet[projectId]) || []
        ];
      }, []))] || [];
    }
   
    this.currentTimezone = this.userProfileService.getProfile('nomad.noc.ng.timezone');
  }

  goToHome = () => {
    this.$state.go('/')
  }

  onMenuClick = (menuItem: AppMenu ) => {
    const data: any = menuItem.params ? {...menuItem.params} : {};
    if (menuItem && menuItem.page) {
      const page = this.$state.get(menuItem.page);
      if (page && page.url && page.url.indexOf(":projectId") !== -1) {
        data.projectId = this.projectService.getSelectedProjectId();
      }
      this.$state.go(menuItem.page, data, {
        inherit: false,
        reload: true
     });
    }
  }

  onTimezoneChanged = (newTimeZone: string) => {
    this.currentTimezone = newTimeZone;
  }

  onLogout = () => {
    this.logout.emit();
  } 

}
